// component select branch and show info branch on header list
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import InputFormat from "../../partials/inputForm";
import { styles } from "./styles";

class SelectBranch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBranch: "",
    };
    // this.inputLabel =  React.useRef(null)
  }
  componentDidMount = () => {
    this.props.serviceBranchDispatch.getListBranch();
    this.props.serviceBranchDispatch.setInfoBranch({});
  };
  handleChange = async (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let state = this.state;
    state[name] = value;
    this.setState({ state });
    if (value === " ") {
      this.props.handleChange("");
    } else {
      this.props.handleChange(value);
    }
    await this.props.serviceBranchDispatch.getInfoBranch(value);
  };

  render() {
    const { t, listBranch = [], classes, hiddenLabel = false } = this.props;
    return (
      <div className={classes.containerBranch}>
        <InputFormat
          select
          fullWidth={true}
          label={hiddenLabel ? "" : t("sidebar_branch")}
          placeholder={t("pls_select")}
          value={this.state.selectedBranch || " "}
          onChange={this.handleChange}
          name="selectedBranch"
          onHeader={true}
          margin="none"
          InputProps={{
            className: classes.root,
          }}
          SelectProps={{
            classes: {
              selectMenu: classes.selectMenu,
            },
          }}
          size="small"
        >
          <MenuItem key={"-1"} value=" ">
            {t("select_branch_with_map_all_branch")}
          </MenuItem>
          {listBranch.map((row, index) => {
            return (
              <MenuItem key={index} value={row.branchCode}>
                {row.branchName}
              </MenuItem>
            );
          })}
        </InputFormat>
      </div>
    );
  }
}

SelectBranch.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  listBranch: state.serviceBranch.listBranch,
});

const mapDispatch = (dispatch) => ({
  serviceBranchDispatch: dispatch.serviceBranch,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(SelectBranch)
  )
);
